import React from 'react';
import { FaAngleLeft } from "react-icons/fa";

const BackButton = ({
  onClick,
  color = 'white',
  text = 'Back to Explore',
  className = '',
  ...props
}) => (
  <div
    className={`text-sm flex items-center gap-1 cursor-pointer pl-5 py-5 slide-in-right ${className}`}
    onClick={onClick}
    {...props}
  >
    <FaAngleLeft color={color} size={20} />
    <div style={{ color }}>{text}</div>
  </div>
);

export default BackButton;